import { FC, SVGAttributes } from 'react';

const Lock: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0038 2.33325C15.479 2.33784 16.8876 2.93837 17.9233 3.9957C18.9582 5.05222 19.5374 6.47886 19.5418 7.96285L19.5418 7.96634L19.5418 9.91237C19.5418 10.5567 19.0195 11.079 18.3752 11.079C17.7308 11.079 17.2085 10.5567 17.2085 9.91237V7.96826C17.2055 7.0859 16.8606 6.24525 16.2564 5.62847C15.6535 5.01301 14.8421 4.67018 14.0002 4.66659C13.1577 4.67019 12.3458 5.01343 11.7428 5.62957C11.1385 6.24713 10.7939 7.08876 10.7918 7.97183V9.91658C10.7918 10.5609 10.2695 11.0832 9.62516 11.0832C8.98083 11.0832 8.4585 10.5609 8.4585 9.91658V7.96813C8.46156 6.48323 9.04016 5.05524 10.0752 3.99758C11.111 2.93912 12.5204 2.33785 13.9965 2.33325H14.0038Z"
        fill="#C8CED4"
      />
      <path
        d="M4.66675 12.2498C4.66675 10.9612 5.71142 9.9165 7.00008 9.9165H21.0001C22.2887 9.9165 23.3334 10.9612 23.3334 12.2498V23.3332C23.3334 24.6218 22.2887 25.6665 21.0001 25.6665H7.00008C5.71142 25.6665 4.66675 24.6218 4.66675 23.3332V12.2498Z"
        fill="#C8CED4"
      />
      <path
        d="M14.9216 18.4473C15.5863 18.1106 16.0418 17.4209 16.0418 16.6249C16.0418 15.4973 15.1277 14.5833 14.0002 14.5833C12.8726 14.5833 11.9585 15.4973 11.9585 16.6249C11.9585 17.4209 12.4141 18.1106 13.0787 18.4473C13.0629 18.4864 13.0511 18.5276 13.0439 18.5707L12.655 20.904C12.5958 21.2596 12.87 21.5833 13.2304 21.5833H14.7699C15.1304 21.5833 15.4046 21.2596 15.3453 20.904L14.9564 18.5707C14.9492 18.5276 14.9375 18.4864 14.9216 18.4473Z"
        fill="#8C929B"
      />
    </svg>
  );
};

export default Lock;
